import { useRuntimeConfig } from "#app";

export function createHeadTitleWithPrefix(text: string): string {
  const prefix = useRuntimeConfig().public.pageTitlePrefix;
  return `${prefix} | ${text}`;
}
